const formatFaqAnswers = () => {
	const answers = document.querySelectorAll('.schema-faq-answer');
	const marker = '– '; // en-dash — Yoast converts "- " to this
	// Yoast may convert "--" to em-dash "—", en-dash "–", or leave as-is
	const endMarkers = ['—', '–—', '--'];

	answers.forEach(answer => {
		const text = answer.textContent.trim();
		if (!text || !text.includes(marker)) return;

		// Find the end-of-list marker and split into before/after
		let mainText = text;
		let afterList = '';

		for (const end of endMarkers) {
			const endIdx = mainText.lastIndexOf(end);
			if (endIdx > -1 && endIdx > mainText.indexOf(marker)) {
				afterList = mainText.substring(endIdx + end.length).trim();
				mainText = mainText.substring(0, endIdx).trim();
				break;
			}
		}

		// Split on en-dash — first part is intro, rest are list items
		const parts = mainText.split(marker);
		let html = '';

		const intro = parts[0].trim();
		if (intro) html += `<p>${intro}</p>`;

		html += '<ul>';
		for (let i = 1; i < parts.length; i++) {
			const item = parts[i].trim();
			if (item) html += `<li>${item}</li>`;
		}
		html += '</ul>';

		if (afterList) html += `<p>${afterList}</p>`;

		answer.innerHTML = html;
	});
};

export const initFaqAccordion = () => {
	const faqContainers = document.querySelectorAll('.schema-faq.wp-block-yoast-faq-block');

	// Only run if the block exists on the page
	if (!faqContainers.length) return;

	formatFaqAnswers();

	faqContainers.forEach(faqContainer => {
		const sections = faqContainer.querySelectorAll('.schema-faq-section');

		sections.forEach(section => {
			section.addEventListener('click', () => {
				const isOpen = section.classList.contains('is-open');

				// Optional: Close other sections when opening a new one
				sections.forEach(s => s.classList.remove('is-open'));

				// If it wasn't open, open it now
				if (!isOpen) {
					section.classList.add('is-open');
				}
			});
		});
	});
};
